// extracted by mini-css-extract-plugin
export default {"card":"i6-z"};